import getMatchingSuggestion from './getMatchingSuggestion'
import { TSuggestElement } from '../../../../../types/factFinder'

const isRedirectToPdpCandidate = (
  searchTerm: string,
  suggestions: TSuggestElement[],
): TSuggestElement | undefined | false => {
  // if we enter a valid and existing sku we will be redirected to the pdp instead of to the search page.
  // for both cases we need to react differently that's why this check exists

  // 1. 6-digit base-product-number
  // 2. one of the suggestions has the searched sku as attribute
  return (
    /* 1. */
    RegExp(/^\d{6}$/).test(searchTerm) &&
    /* 2. */
    getMatchingSuggestion(searchTerm, suggestions)
  )
}

export default isRedirectToPdpCandidate
